import { GiftOutlined, MenuOutlined } from '@ant-design/icons';
import { Button, Dropdown, Flex, Layout, Space, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { getRoleByValue, handleLogout } from '../../../../utils';
import UserAvatar from '../../../ui/UserAvatar';
import Branding from './../../../ui/Branding';
import ResponsiveMenu from './ResponsiveMenu';
import { Activity, useState } from 'react';

const { Header } = Layout;

const PrivateHeader = () => {
    const { user } = useSelector((state) => state.authSlice);
    const [open, setOpen] = useState(false);

    const renderUserProfile = () => (
        <Flex align="center" gap={10} onClick={(e) => e.stopPropagation()}>
            <UserAvatar user={user} size={40} />
            <Space direction="vertical" size={0}>
                <Typography.Text strong>{user?.name}</Typography.Text>
                <Typography.Text type="secondary">
                    {user?.email ?? getRoleByValue(user?.role)}
                </Typography.Text>
            </Space>
        </Flex>
    );

    const items = [
        {
            key: 'profile',
            label: renderUserProfile(),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: (
                <Flex justify="center">
                    <Button type="link" danger>
                        Logout
                    </Button>
                </Flex>
            ),
            onClick: handleLogout,
        },
    ];

    return (
        <Header className="app-header px-4">
            <Branding />
            <Flex align="baseline" gap={10} className="header-actions">
                <Button type="primary" icon={<GiftOutlined />} className="offer-button">
                    Exclusive Offers
                </Button>
                <Dropdown
                    menu={{
                        items,
                    }}
                    trigger={['click']}
                    className="user-info"
                >
                    <div>
                        <UserAvatar user={user} size={40} />
                    </div>
                </Dropdown>
            </Flex>
            <Button icon={<MenuOutlined />} className="responsive-menu" onClick={() => setOpen(true)} />

            <Activity mode={open ? 'visible' : 'hidden'}>
                <ResponsiveMenu profile={renderUserProfile} open={open} onClose={() => setOpen(false)} />
            </Activity>
        </Header>
    );
};

export default PrivateHeader;
